import React from 'react';
import Config from 'Config';
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker
} from 'react-google-maps';

const MapWithMarkers = withScriptjs(withGoogleMap(props =>
	<GoogleMap defaultZoom={props.defaultZoom || 18} defaultCenter={{ lat: props.latitude, lng: props.longitude }}
		onClick={props.onMapClick}>
		{props.isSingleMarker && <Marker position={{ lat: props.latitude, lng: props.longitude }} />}
		{props.markers && props.markers.map(marker => <Marker key={marker.id}
			position={{ lat: marker.latitude, lng: marker.longitude }}
			onClick={() => props.onMarkerClick(marker)}>
			{props.activeMarkerKey == marker.id && props.infoWindow(marker)}
		</Marker>)}
	</GoogleMap>
));

const MapComponent = ({ latitude, longitude, isSingleMarker, markers, defaultZoom,
	onMarkerClick, activeMarkerKey, height, infoWindow, onMapClick }) => {
	const googleApiKey = Config.googleApiKey;

	return <MapWithMarkers
		defaultZoom={defaultZoom}
		latitude={latitude}
		longitude={longitude}
		isSingleMarker={isSingleMarker}
		markers={markers}
		activeMarkerKey={activeMarkerKey}
		onMarkerClick={onMarkerClick}
		onMapClick={onMapClick}
		infoWindow={infoWindow}
		googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&v=3.exp&libraries=geometry,drawing,places`}
		loadingElement={<div style={{ height: `100%` }} />}
		containerElement={<div style={{ height: height || `300px` }} />}
		mapElement={<div style={{ height: `100%` }} />}
	/>;
};

export default MapComponent;